import IdeRunner from "./IdeRunner"
import { postsApi } from '../../../utils'
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import classes from './IdeRunnerWarrer.module.css'
import Header from "../../Header/Header";
import { applicationActions } from "../../../store/application-slice";
import { onKeyDown } from "../service";
import HomeIcon from '../assests/home.png';
import SkillzIcon from '../assests/skillz.png';
import CampuzIcon from '../assests/campuz.png';

const IdeRunnerWarrper = () => {
    const dispatch = useDispatch();
    const { applictionName, postId } = useParams();
    const [projectData, setProjectData] = useState()
    const baseDispatch = useDispatch()
    const { texts, lang } = useSelector(state => state.translate);
    const { homeUrl } = useSelector((state) => state.application);
    const uiData = useSelector((state) => state.general.uiData);
    const navigate = useNavigate();

    useEffect(() => {
        if (uiData)
            dispatch(applicationActions.setInitial({ applictionName, uiData }))
    }, [dispatch, uiData])

    useEffect(() => {
        if (lang) {
            postsApi.postsFilterPublicIdPost(postId, (error, resdata, response) => {
                if (error) {
                    baseDispatch(throwApiError({ userMessage: texts.projectsFilterIdError, error: error, statusCode: response?.statusCode, message: "projectsFilterIdPost " + error.message, level: 2, component: "Project", line: 58 }))
                } else {
                    if (resdata) {

                        let ide = JSON.parse(resdata.contentData)
                        setProjectData({
                            projectId: resdata.id,
                            assessmentName: resdata.name,
                            ideId: ide.Ide.Id,
                            ideUrl: ide.Ide.Url,
                            ideLang: ide.Ide.Lang ? ide.Ide.Lang : lang,
                            ideConfig: JSON.parse(ide.Ide.AdditionalConfiguration),
                            fileUrl: resdata.url,
                            share: true
                        })
                    }
                }
            })
        }
    }, [lang])

    const hideHeader = () => {
        return window.location.href.includes('noheader=1');
    }

    return (
        <>
            {hideHeader() ? '' :
                <div className={classes.Header}>
                    <img src={HomeIcon} className={classes.Icon} onClick={() => navigate(homeUrl)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => navigate(homeUrl))}></img>
                    <img src={SkillzIcon} className={`${classes.Icon} ${classes.SkillzIcon}`} onClick={() => navigate(homeUrl)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => navigate(homeUrl))}></img>
                    <img src={CampuzIcon} className={`${classes.Icon} ${classes.CampuzIcon}`} onClick={() => navigate(homeUrl)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => navigate(homeUrl))}></img>
                </div>}
            <div className={`${classes.IdeRunnerWarrper} ${hideHeader() ? classes.IdeRunnerWarrperWOHeader : ''}`}>
                {projectData && <IdeRunner projectData={projectData} />}
            </div>
        </>
    )
}
export default IdeRunnerWarrper